import { CSSProperties } from 'react';

export default function EmptyPhone({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <g clipPath="url(#clip0_1267_18656)">
        <mask
          id="mask0_1267_18656"
          maskUnits="userSpaceOnUse"
          x="-1"
          y="0"
          width="42"
          height="42"
        >
          <path d="M-1 0H41V42H-1V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1267_18656)">
          <path
            d="M27.8276 36.5963H12.4848C12.3391 36.5963 12.1949 36.5676 12.0603 36.5118C11.9257 36.4561 11.8034 36.3743 11.7004 36.2713C11.5974 36.1683 11.5157 36.046 11.4599 35.9115C11.4042 35.7769 11.3755 35.6326 11.3755 35.4869V6.48568C11.3755 6.34 11.4042 6.19575 11.4599 6.06117C11.5157 5.92658 11.5974 5.80429 11.7004 5.70128C11.8034 5.59827 11.9257 5.51656 12.0603 5.46081C12.1949 5.40507 12.3391 5.37637 12.4848 5.37637H27.8276C27.9732 5.37637 28.1175 5.40507 28.2521 5.46081C28.3867 5.51656 28.5089 5.59827 28.612 5.70128C28.715 5.80429 28.7967 5.92658 28.8524 6.06117C28.9082 6.19575 28.9369 6.34 28.9369 6.48568V35.4869C28.9369 35.6326 28.9082 35.7769 28.8524 35.9115C28.7967 36.046 28.715 36.1683 28.612 36.2713C28.5089 36.3743 28.3867 36.4561 28.2521 36.5118C28.1175 36.5676 27.9732 36.5963 27.8276 36.5963Z"
            stroke="#250058"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.0746 34.7588H24.2378"
            stroke="#1399D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.0915 5.376H15.445C15.9239 5.376 16.3396 5.90184 16.4473 6.36871V6.17341C16.5227 6.49933 16.8127 6.92521 17.1471 6.92521H23.1654C23.3278 6.92523 23.4853 6.87021 23.6124 6.76914C23.7395 6.66807 23.8285 6.52691 23.865 6.36871V6.17341C23.9173 5.94674 24.0449 5.74448 24.227 5.59964C24.409 5.45481 24.6348 5.37594 24.8674 5.37592H25.2862"
            fill="#250058"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1267_18656">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
